<template>
  <div>
    <input ref="files" @change="update" type="file" hidden/>
    <el-button v-if="isShow" class="btn" size="small" @click="openFile">点击上传</el-button>
    <div v-if="fileinfo.md5 || md5s" class="icon">
      <img :src="`${this.getaway.user}bt/file/${fileinfo.md5}/download`" alt="">
    </div>
  </div>
</template>

<script>
import BigUpload from '@/js/upload'

export default {
  name: 'pictureIcon',
  props: {
    md5s: {
      type: String,
      default: ''
    },
    uploadStatus: {
      type: Boolean,
      default: true
    },
    isShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      file: '',
      // 防止重复提交
      loading: false,
      fileinfo: {},
      uploadFile: null
    }
  },
  //定义v-model属性
  model: {
    prop: 'md5s',
    event: 'change'
  },
  watch: {
    //监听缩略图的修改
    md5s(val) {
      this.fileinfo.md5 = val
    }
  },
  created() {
    if (this.md5s) {
      this.fileinfo.md5 = this.md5s
    }
  },

  methods: {
    //触发单击事件
    openFile() {
      this.$refs.files.click()
    },

    update() {
      this.uploadFile = new BigUpload({
        url: `${this.getaway.user}bt/files/bigupload`,
        file: this.$refs.files,
        size: 2097152,
        callback: (state) => {
          if (state) {
            this.fileinfo = {
              md5: state.md5,
              createDatetime: state.createDatetime,
              name: state.name
            }
            this.dialogVisible = false
            this.loading = false
            this.$emit('change', state.md5)
            this.$emit('getImgMd5', this.fileinfo)
          }
        }
      })
      this.uploadFile.startUpload()
    },

    //确定
    finish() {
      this.loading = true
      this.$refs.cropper.getCropBlob((data) => {
        let file = new window.File([data], '', {type: data.type})
        let files = {
          files: []
        }
        files.files.push(file)

      })
    },
  }
}
</script>

<style lang="less" scoped>
.icon {
  padding-top: 10px;
}
</style>
